// @flow
import { connect } from 'react-redux';
import { fetchCardSwapLogsRequest } from 'redux/Machine/actions';
import { cardSwapLogs } from 'redux/Machine/selectors';
import CardSwapDashboard from './CardSwapDashboard.component';
import type { DispatchPropsType, StatePropsType } from './CardSwapDashboard.component';

const mapStateToProps = (state: StoreType): StatePropsType => ({
  logs: cardSwapLogs(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchPropsType => ({
  fetchAllLogsRequest: () => dispatch(fetchCardSwapLogsRequest()),
});

export default (connect(mapStateToProps, mapDispatchToProps)(CardSwapDashboard): any);
